import { UpdateProcessingActivityAssessmentRequest } from '@ketch-com/api/dist/supercargo/processing_activity'
import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'

interface UpdateProcessingActivityAssessmentListParams
  extends Omit<UpdateProcessingActivityAssessmentRequest, 'file'> {}

export const updateProcessingActivityAssessmentList = ({
  processingActivityID,
  assessmentID,
}: UpdateProcessingActivityAssessmentListParams) => {
  const entityUrl = `/api/risk-review/processing-activities/${processingActivityID}/assessments/${assessmentID}`
  return API.put(
    formatRequestString({
      entityUrl,
    }),
  )
}
